import { FormControl, FormLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { chartOptionToggleGroupSx } from "../../lib/ui/formLayout";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";
import type { ChartOrientation } from "../../utils/chartTypeRegistry";

type Props = {
  value: ChartOrientation;
  disabled?: boolean;
  onChange: (value: ChartOrientation) => void;
};

export default function ChartOrientationField({ value, disabled, onChange }: Props) {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();

  return (
    <FormControl fullWidth margin="dense" size="small" disabled={disabled}>
      <FormLabel sx={custom.components.chartOptionPanels.orientationLabel}>
        {t("chartEditor.orientation")}
      </FormLabel>
      <ToggleButtonGroup
        size="small"
        exclusive
        disabled={disabled}
        value={value || "vertical"}
        onChange={(_, next: ChartOrientation | null) => {
          if (next) onChange(next);
        }}
        sx={chartOptionToggleGroupSx}
      >
        <ToggleButton value="vertical">{t("chartEditor.vertical")}</ToggleButton>
        <ToggleButton value="horizontal">{t("chartEditor.horizontal")}</ToggleButton>
      </ToggleButtonGroup>
    </FormControl>
  );
}
